import Action from "../actions";

export default function calculationFormulaManagementReducer(state = {
    listCalFormula: []
}, action) {
    if (action.type === Action.SET_CALCULATION_FORMULA_MANAGEMENT) {
        return action.data;
    }
    return state;
}
